import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { CouponStatus } from '@constants/coupons';

export const useCouponsTemplates = () => {
    const coupons = useSelector(state => state.coupons.data);

    const mapTemplatePropsToOption = coupon => ({
        value: coupon.id,
        label: coupon.title,
    });

    const getCouponsOptionsByLocation = useCallback(
        locationId => {
            return coupons
                .filter(coupon => coupon.locationId === locationId && coupon.status === CouponStatus.Active)
                .map(mapTemplatePropsToOption);
        },
        [coupons],
    );

    const getCouponsOptionsByBrand = useCallback(
        brandId => {
            return coupons
                .filter(coupon => coupon.brandId === brandId && coupon.status === CouponStatus.Active)
                .map(mapTemplatePropsToOption);
        },
        [coupons],
    );

    return {
        getCouponsOptionsByLocation,
        getCouponsOptionsByBrand,
    };
};
